@if (filterVisible) {
  <!-- A panel of its own height, the results stay in view below. -->
  <div class="filter-panel" id="search-filter-panel">
    <app-companies-filter
      [filter]="builderFilter"
      [filterEnabled]="!listLoading"
      [liveDelay]="400"
      (filterChange)="builderChange.emit($event)"
      (submitted)="builderSubmit.emit()"
    ></app-companies-filter>
  </div>
}
<div
  class="app-table app-table-striped app-table-hoverable-rows app-table-resizable app-table-scrollable hunter-grid app-fill-table"
  [class.has-error]="companies?.error"
>
  <div class="app-table-header">
    <div class="grid-toolbar">
      @if (selectedCompanies.length) {
        <app-add-to-list-button
          [lists]="lists$ | async"
          (listSelected)="listClicked($event)"
        ></app-add-to-list-button>
      }
      <button
        matIconButton
        type="button"
        class="column-chooser-button"
        title="Column Chooser"
        (click)="columnChooser.toggle($event)"
      >
        <i class="fa-solid fa-table-columns"></i>
      </button>
    </div>
    <!-- A failed search shows the error in the place of the headers. -->
    @if (companies?.error) {
      <app-grid-error
        [message]="companies?.error || null"
        (closed)="companies?.clearError()"
      ></app-grid-error>
    }
  </div>
  <p class="table-scroll-hint">
    <i class="fa-solid fa-arrows-left-right" aria-hidden="true"></i>
    {{ 'common.label.moreColumns' | translate }}
  </p>
  <div
    class="app-table-wrapper"
    appScrollFade
    [appVirtualRows]="companies?.items?.length || 0"
    (nearEnd)="loadMore()"
    #rows="appVirtualRows"
  >
    <table class="app-table-table" role="table">
      <thead class="app-table-thead">
        <tr
          cdkDropList
          cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="onColumnDrop($event)"
        >
          <th class="selection-cell">
            <app-table-checkbox
              [ariaLabel]="
                'common.label.selectAllLoaded'
                  | translate: { count: companies?.items?.length || 0 }
              "
              [attr.title]="
                'common.label.selectAllLoaded'
                  | translate: { count: companies?.items?.length || 0 }
              "
              [checked]="allSelected"
              (toggled)="toggleAll()"
            ></app-table-checkbox>
          </th>
          @for (column of visibleColumns; track column.key) {
            <th
              cdkDrag
              cdkDragLockAxis="x"
              cdkDragPreviewClass="app-column-drag-preview"
              (cdkDragStarted)="dragging = true"
              (cdkDragEnded)="onColumnDragEnded()"
              [class.app-sortable-column]="column.sortable"
              [class.app-highlight]="
                column.field && sort?.field === column.field
              "
              [attr.data-column]="column.key"
              [style.width.px]="column.width"
              [style.max-width.px]="column.width"
              [style.text-align]="column.alignment"
              [attr.tabindex]="column.sortable ? 0 : null"
              (click)="onHeaderClick($event, column)"
              (keydown.enter)="onHeaderClick($event, column)"
              (contextmenu)="onHeaderContextMenu($event, column)"
            >
              {{ column.header }}
              @if (column.sortable) {
                <app-sort-icon
                  [field]="column.field || ''"
                  [sort]="sort"
                ></app-sort-icon>
              }
              <span
                appColumnResizer
                (columnResize)="onColumnResize($event)"
              ></span>
            </th>
          }
        </tr>
      </thead>
      <!-- The rows above and below the rendered ones (appVirtualRows). -->
      <tbody class="virtual-before" aria-hidden="true">
        <tr>
          <td
            class="virtual-spacer"
            [attr.colspan]="visibleColumns.length + 1"
            [style.height.px]="rows.before"
          ></td>
        </tr>
      </tbody>
      <tbody class="app-table-tbody">
        @for (
          company of $any(companies?.items | rowWindow: rows.start : rows.end);
          track company.business_id;
          let offset = $index
        ) {
          @let rowIndex = rows.start + offset;
          <tr
            [attr.data-row-index]="rowIndex"
            [class.row-selected]="isSelected(company)"
            [class.row-last-opened]="company.business_id === lastOpenedId"
            (click)="onRowClick($event, company, rowIndex)"
            (auxclick)="onRowAuxClick($event, company, rowIndex)"
            (contextmenu)="onRowContextMenu($event, company, rowIndex)"
          >
            <td class="selection-cell" (click)="onSelectionCellClick(company)">
              <app-table-checkbox
                [checked]="isSelected(company)"
                (toggled)="toggleRow(company)"
              ></app-table-checkbox>
            </td>
            @for (column of $any(visibleColumns); track column.key) {
              <td
                [style.width.px]="column.width"
                [style.min-width.px]="column.width"
                [style.max-width.px]="column.width"
                [style.text-align]="column.alignment"
              >
                @switch (column.template) {
                  @case ('cellDescriptionTemplate') {
                    <span
                      class="description-cell"
                      [innerHTML]="company[column.field]"
                      [appTooltip]="company[column.field] | sanitizeHtml"
                      [tooltipEscape]="false"
                      tooltipPosition="top"
                      tooltipStyleClass="description-tooltip"
                    ></span>
                  }
                  @case ('cellInvestorsTemplate') {
                    @for (investor of company[column.field]; track investor) {
                      <a
                        class="hover-underline w3-margin-right"
                        [routerLink]="
                          '/companies/' +
                          encodeURIComponent(investor.business_id) +
                          '/overview'
                        "
                        >{{ investor.name }}</a
                      >
                    }
                  }
                  @case ('cellIconTemplate') {
                    <section class="media-links">
                      <ng-template
                        [ngTemplateOutlet]="mediaLink"
                        [ngTemplateOutletContext]="{
                          url: company.facebook_url,
                          icon: 'fa-brands fa-facebook',
                          isAlt: isAltRow(rowIndex),
                        }"
                      ></ng-template>
                      <ng-template
                        [ngTemplateOutlet]="mediaLink"
                        [ngTemplateOutletContext]="{
                          url: company.linkedin_url,
                          icon: 'fa-brands fa-linkedin',
                          isAlt: isAltRow(rowIndex),
                        }"
                      ></ng-template>
                      <ng-template
                        [ngTemplateOutlet]="mediaLink"
                        [ngTemplateOutletContext]="{
                          url: company.twitter_url,
                          icon: 'fa-brands fa-twitter',
                          isAlt: isAltRow(rowIndex),
                        }"
                      ></ng-template>
                      <ng-template
                        [ngTemplateOutlet]="mediaLink"
                        [ngTemplateOutletContext]="{
                          url: company.website_url,
                          icon: 'fa-solid fa-globe',
                          isAlt: isAltRow(rowIndex),
                        }"
                      ></ng-template>
                    </section>
                  }
                  @default {
                    <a
                      class="row-link"
                      [routerLink]="company.business_id | companyLink: context"
                      [queryParams]="rowIndex | rowParams: contextQueryParams"
                      >{{ company[column.field] | cellFormat: column }}</a
                    >
                  }
                }
              </td>
            }
          </tr>
        } @empty {
          @if (!companies?.error) {
            <tr>
              <td class="no-data" [attr.colspan]="visibleColumns.length + 1">
                @if (listLoading) {
                  {{ 'common.label.stillSearching' | translate }}
                } @else if (state?.filterValue?.length) {
                  <p class="empty-title">
                    {{ 'search.empty.title' | translate }}
                  </p>
                  <button
                    type="button"
                    class="empty-action"
                    (click)="filterChanged(null)"
                  >
                    {{ 'common.action.resetFilters' | translate }}
                  </button>
                } @else {
                  {{
                    (state ? 'search.label.noData' : 'search.label.hint')
                      | translate
                  }}
                }
              </td>
            </tr>
          }
        }
      </tbody>
      <tbody class="virtual-after">
        <tr aria-hidden="true">
          <td
            class="virtual-spacer"
            [attr.colspan]="visibleColumns.length + 1"
            [style.height.px]="rows.after"
          ></td>
        </tr>
        @if (companies?.items?.length) {
          <tr class="list-end-row">
            <td [attr.colspan]="visibleColumns.length + 1">
              @if (companies?.moreError) {
                <span class="list-end-error">{{
                  companies?.moreError || '' | translate
                }}</span>
                <button
                  type="button"
                  class="empty-action"
                  (click)="retryMore()"
                >
                  {{ 'common.action.retry' | translate }}
                </button>
              } @else if (companies?.isComplete) {
                {{ 'common.label.endOfList' | translate }}
              } @else {
                <span class="loading-more" role="status"
                  ><i
                    class="app-icon fa-solid fa-spinner fa-spin"
                    aria-hidden="true"
                  ></i>
                  {{ 'common.label.loadingMore' | translate }}</span
                >
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (companies?.isLoaded && !companies?.error) {
    <div class="table-status" role="status">
      {{
        (companies?.totalRecords === 1
          ? 'common.label.companyCountOne'
          : 'common.label.companyCount'
        ) | translate: { count: (companies?.totalRecords | companyTotal) }
      }}
      @if (selectedCompanies.length) {
        <span class="table-status-selected">{{
          'common.label.selectedCount'
            | translate: { count: (selectedCompanies.length | number) }
        }}</span>
      }
    </div>
  }
</div>

<app-context-menu #rowMenu [model]="rowMenuItems"></app-context-menu>
<app-context-menu #headerMenu [model]="headerMenuItems"></app-context-menu>

<app-overlay-panel #columnChooser styleClass="column-chooser">
  <div class="column-chooser-title">Column Chooser</div>
  @for (column of chooserColumns; track column) {
    <div class="column-chooser-item">
      <mat-checkbox
        [ngModel]="column.visible"
        (ngModelChange)="setColumnVisible(column, $event)"
        >{{ column.header }}</mat-checkbox
      >
    </div>
  }
</app-overlay-panel>

<ng-template #mediaLink let-icon="icon" let-url="url" let-isAlt="isAlt">
  @if (url) {
    <a [href]="url" target="_blank">
      <i
        class="w3-text-theme-secondary margin-horizontal-xs"
        [ngClass]="icon"
      ></i>
    </a>
  } @else {
    <i
      class="margin-horizontal-xs"
      [ngClass]="icon + (isAlt ? ' w3-text-white' : ' w3-text-theme-tertiary')"
    ></i>
  }
</ng-template>
